import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => {
    return state[NAME];
};

export const getFetchProducts = createSelector(
    getModel,
    (model) => model.fetchProducts,
);

export const getFetchProductsData = createSelector(
    getFetchProducts,
    (model) => model.data,
);

export const getFetchItems = createSelector(
    getModel,
    (model) => model.fetchItems,
);

export const getIsFetchingItems = createSelector(
    getFetchItems,
    (model) => model.isFetching,
);

export const getFetchItemsData = createSelector(
    getFetchItems,
    (model) => model?.data?.data,
);

export const getFetchItemsPagination = createSelector(
    getFetchItems,
    (model) => model?.data?.pagination,
);

export const getFetchItem = createSelector(
    getModel,
    (model) => model.fetchItem,
);

export const getIsFetchingItem = createSelector(
    getFetchItem,
    (model) => model.isFetching,
);

export const getFetchItemData = createSelector(
    getFetchItem,
    (model) => model.data,
);

export const getFetchTemplates = createSelector(
    getModel,
    (model) => model.fetchTemplates,
);

export const getFetchTemplatesData = createSelector(
    getFetchTemplates,
    (model) => model.data,
);

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getIsInitializing = createSelector(
    getModel,
    (model) => model.isInitializing,
);
export const getIsNewRecord = createSelector(
    getModel,
    (model) => model.isNewRecord,
);
export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);
export const getIsOpenModalProduct = createSelector(
    getModel,
    (model) => model.isOpenModalProduct,
);

export const getSaveItem = createSelector(getModel, (model) => model.saveItem);

export const getIsSavingItem = createSelector(
    getSaveItem,
    (model) => model.isSaving,
);

export const getSaveItemErrors = createSelector(
    getSaveItem,
    (model) => model.errors,
);

//Countries
export const getCountriesModel = createSelector(
    getModel,
    (model) => model.countries || {},
);

export const getCountriesData = createSelector(
    getCountriesModel,
    (model) => model.data || [],
);

export const getCountriesToSelect = createSelector(getCountriesData, (model) =>
    model.map((brand) => ({
        label: brand.name,
        value: brand.id,
    })),
);

export const getRoofTypesModel = createSelector(
    getModel,
    (model) => model.fetchRoofTypes || {},
);

export const getRoofTypesData = createSelector(
    getRoofTypesModel,
    (model) => model.data || [],
);

export const getRoofTypesToSelect = createSelector(getRoofTypesData, (model) =>
    model.map((type) => ({
        label: type.name,
        value: type.key,
    })),
);
